import "./widgets.css";

const Widgets = ({ icon = null, button = null, edit=null,  body="" }) => {
  return (
    <div className="widgets-container">
      <div className={button != null || icon !== null ? "widgets-header-bordered" : "widgets-header"}>
        <div className="widgets-header-left">
            {icon} 
        </div>
        <div className="widgets-header-right">
            {button} {edit}
        </div> 
      </div>

      <div className="widgets-body">
        {body}
      </div>
    </div>
  );
};

export default Widgets;
